import { Avatar } from "@mantine/core";

interface Testimonial {
    content: string;
    name: string;
    designation: string;
    avatar: string;
}

const testimonials: Testimonial[] = [
    {
        content:
            "I never use spaced repetition to review my openings. I see openingtrainer as similar to playing blitz games, with the advantages of: a) it's focused on the opening only. b) not saving my opening prep in a public place.  c) can easily focus on a particular opening.",
        name: "kiwiPete",
        designation: "",
        avatar: "kiwiPete.png",
    },
    {
        content:
            "I'm enjoying Opening Trainer. I was unsure of the value vs using Lichess Tools to train against the Lichess DB.  It's great being able to not be limited to my desktop to do this kind of thing!",
        name: "ChrisL64",
        designation: "",
        avatar: "ChrisL64.png",
    },
    {
        content:
            "A discord server I am in with only people 2000+ has several people starting to use OpeningTrainer as a core part of their training. Just super useful to get reps against rare gambits played by master level players.",
        name: "Zweb",
        designation: "",
        avatar: "Zweb.png",
    },
    {
        content:
            "I tend to use a wide variety of tools and get value from all of them. My routine would generally be building and maintaining my repertoire in ChessBook […] and practicing in OpeningTrainer (which I find more enjoyable than drilling).",
        name: "mattchess",
        designation: "",
        avatar: "mattchess.png",
    },
    {
        content:
            "Openingtrainer gave me a comfortable space to explore the moves that get played most often in the openings I want to practice, figure out how to deal with them, and get practice and repetitions doing so.",
        name: "raskerino",
        designation: "",
        avatar: "raskerino.png",
    },
    {
        content: "Just want to say how great your trainers are and how much I appreciate your support",
        name: "4saken",
        designation: "",
        avatar: "discord.png",
    },
    {
        content:
            "I didn't know that I needed this, but it actually seems incredible useful. During a game I am always wondering somewhere in the opening phase if my choices were right, but then I have to continue the full game before I can analyse. This really helps with opening practice.",
        name: "TicketSuggestion",
        designation: "",
        avatar: "TicketSuggestion.png",
    },
    {
        content:
            "Thanks for adding that move exclusion feature to the app.  I really do think you have made something great that will have an impact on chess improvement.  Your app has made me approach chess in a new way now, and I am enjoying chess a lot more and playing much more aggresively. Cheers.",
        name: "chessimple",
        designation: "",
        avatar: "chessimple.png",
    },
    {
        content:
            "Great investment if you want to improve your openings...love the interface, the lichess integration, everything!",
        name: "CFU4ever",
        designation: "",
        avatar: "",
    },
];

export const TestimonialCard = ({ item }: { item: Testimonial }) => (
    <div className="h-auto">
        <div className="rounded-lg bg-[#25262b] px-7 py-10 md:mx-32 lg:max-w-96 lg:mx-4">
            <div className="text-dark dark:text-white">
                <svg width="33" height="20" viewBox="0 0 33 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.28375 19.41L0.79375 18.64C1.21375 17.0067 1.75042 15.07 2.40375 12.83C3.05708 10.5433 3.75708 8.28 4.50375 6.04C5.29708 3.75333 6.06708 1.77 6.81375 0.0899959H15.3538C14.9338 2.09666 14.4904 4.26667 14.0238 6.6C13.5571 8.88666 13.1371 11.15 12.7638 13.39C12.4371 15.5833 12.1571 17.59 11.9238 19.41H1.28375ZM31.69 0.0899959L32.18 0.859998C31.76 2.54 31.2233 4.5 30.57 6.74C29.9167 8.98 29.2167 11.2433 28.47 13.53C27.7233 15.77 26.9533 17.73 26.16 19.41H17.69C18.0167 17.9167 18.3433 16.33 18.67 14.65C18.9967 12.9233 19.3 11.22 19.58 9.54C19.9067 7.81333 20.1867 6.15667 20.42 4.57C20.7 2.93666 20.91 1.44333 21.05 0.0899959H31.69Z"
                        fill="currentColor"
                    />
                </svg>
            </div>
            <blockquote className="mt-8">{item.content}</blockquote>
            <div className="mt-11 flex items-center">
                <div className="text-dark dark:text-white">
                    <Avatar src={item.avatar} alt={item.name} />
                </div>
                <div className="ml-4">
                    <h3 className="h5 font-primary font-semibold">{item.name}</h3>
                    <p className="text-dark dark:text-white">{item.designation}</p>
                </div>
            </div>
        </div>
    </div>
);

const Testimonials = () => {
    return (
        <div className="text-left flex justify-center">
            <div>
                <div>
                    <div className="swiper testimonial-slider">
                        <div className="swiper-wrapper grid grid-cols-1 lg:grid-cols-3 w-fit space-y-8 lg:space-y-0 gap-0">
                            <div className="space-y-8">
                                {testimonials.slice(0, 3).map((item) => (
                                    <TestimonialCard item={item} />
                                ))}
                            </div>
                            <div className="space-y-8">
                                {testimonials.slice(3, 6).map((item) => (
                                    <TestimonialCard item={item} />
                                ))}
                            </div>
                            <div className="space-y-8">
                                {testimonials.slice(6, 9).map((item) => (
                                    <TestimonialCard item={item} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
